import type { Color } from "../types/colors/Color"
import type { HSLColor } from "../types/colors/HSLColor"
import { RgbToHsl } from "./RgbToHsl"
import { ToRgb } from "./ToRgb"

/**
 * Converts a Color to an HSLColor
 * If the input is already HSL, it will be returned as is
 * If the input is RGB or CMYK, it will be converted to HSL
 */
export const ToHsl = (color: Color): HSLColor => {
  if ("h" in color) {
    // It's already an HSLColor
    return color
  } else if ("r" in color) {
    // It's an RGBColor, convert to HSL
    return RgbToHsl(color)
  } else {
    // It's a CMYKColor, first convert to RGB, then to HSL
    const rgb = ToRgb(color)
    return RgbToHsl(rgb)
  }
}
